module.exports = __webpack_public_path__ + "static/media/badge-help-right.4f98ccb8.svg";